import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LoadingIndicator from "../components/LoadingIndicator";
import { redirectRentalCheckout } from "../store/prypool_products/operations";
import { isFetchingRentalSession } from "../store/prypool_products/selectors";
import { useDispatch } from "react-redux";
import { SITE_URL, RENTAL_THANK_YOU_PAGE } from "../config";
import { useLocation } from "react-router-dom";
import { isLoggedIn, loggedInUserGuid } from "../store/iam/selectors";
import GrannboxLogin from "./GrannboxLogin";
import GrannboxRegister from "./GrannboxRegister";
import GrannboxForgotPassword from "./GrannboxForgotPassword";
import LanguageSelector from "../components/LanguageSelector/LanguageSelector";
import ihopaLogo from "../styles/images/logo-ihopa-new.svg";
import Div100vh from "react-div-100vh";
import "../styles/grannboxOnboarding.scss";

function useQuery() {
    return new URLSearchParams(useLocation().search);
}

export default function RentalsCheckout(props) {
    let query = useQuery();
    const start_time = query.get("start_time");
    const end_time = query.get("end_time");
    const circle_guid = query.get("circle_guid");
    const success_url = query.get("success_url");

    const [activePage, setPage] = useState(""); //login | register | recover_password
    const dispatch = useDispatch();
    const isLogged = useSelector(isLoggedIn);
    const myGuid = useSelector(loggedInUserGuid);
    const fetchingRentalSession = useSelector(isFetchingRentalSession);

    const goToCheckout = () => {
        let successUrl = RENTAL_THANK_YOU_PAGE;
        if (success_url) {
            successUrl = `${success_url}?circle_guid=${circle_guid}`;
        }
        const payload = {
            circle_guid: circle_guid,
            start_time: start_time,
            end_time: end_time,
            user_guid: myGuid,
            success_url: successUrl,
            cancel_url: `${SITE_URL}/rent-circle/${circle_guid}`,
        };
        dispatch(redirectRentalCheckout(payload));
    };

    useEffect(() => {
        if (!isLogged) {
            setPage("register");
        }
        isLogged && goToCheckout();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLogged]);

    if (!activePage || fetchingRentalSession) {
        return <LoadingIndicator />;
    }
    return (
        <Div100vh className="grannbox-onboarding-wrapper">
            <div className="grannbox-form-wrapper">
                <div className="grannbox-logo">
                    <img src={ihopaLogo} alt="ihopa logo" />
                    <LanguageSelector />
                </div>
                {activePage === "login" && <GrannboxLogin goTo={setPage} />}
                {activePage === "register" && <GrannboxRegister goTo={setPage} />}
                {activePage === "recover_password" && <GrannboxForgotPassword goTo={setPage} />}
            </div>
        </Div100vh>
    );
}
